import { render } from "./editProductView.vue?vue&type=template&id=12808c8d&scoped=true"
import script from "./editProductView.vue?vue&type=script&lang=js"
export * from "./editProductView.vue?vue&type=script&lang=js"

import "./editProductView.vue?vue&type=style&index=0&id=12808c8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12808c8d"]])

export default __exports__